// Strip trailing slash so we never get double slashes (e.g. /api/countries not //api/countries)
const _base = (process.env.REACT_APP_BASE_URL || 'http://localhost:3000').replace(/\/$/, '');
export const BASE_URL = _base;
export const API_URL = `${_base}/api`;

// Public-facing site URL (used for canonical/OG tags) — distinct from BASE_URL, which is the API host.
export const SITE_URL = (process.env.REACT_APP_SITE_URL || 'https://visitallnepal.com').replace(/\/$/, '');

export const FLIGHT_API_URL = `${API_URL}/flights`;
export const USER_API_URL = `${API_URL}/members`
export const GOOGLE_AUTH_URL = `${BASE_URL}/users/auth/google_oauth2`
export const FACEBOOK_AUTH_URL = `${BASE_URL}/users/auth/facebook`
export const ADMIN_API_URL = `${API_URL}/admin`
export const TRANSACTION_API_URL = `${BASE_URL}/admin`
export const PAYMENT_URL = `${BASE_URL}/payments`